import React from 'react';
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../store/actions/messageActions';

import '../../../assets/css/chat.css';

const Messages = props => {
    const [messages, setMessages] = useState([]);
    const oldMessages = useSelector(state => state.message.messages);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.fetchMessageRoomMessages(props.getMessageRoom()));
        props.hubConnection.on(props.getMessageRoom(), message => {
            setMessages(prevState => [...prevState, message]);
        });
    }, []);

    const renderOldMessages = (message, key) => {
        const {profileId, messageText} = message;
        const messageFromMe = profileId === props.currentMember.profileId;
        const className = messageFromMe ? "sent-chat" : "received-chat";

        return (
            <div className={className} key={key}>
                <p>{messageText}</p>
            </div>
        );
    }

    const renderMessage = (message, key) => {
        const {profileId, messageText} = message;
        const messageFromMe = profileId === props.currentMember.profileId;
        const className = messageFromMe ? "sent-chat" : "received-chat";

        return (
            <div className={className} key={key}>
                <p>{messageText}</p>
            </div>
        );
    }

    return (
        <div className="chat-screen">
            {oldMessages.map((m,i) => renderOldMessages(m,i))}
            {messages.map((m,i) => renderMessage(m,i))}
        </div>
    );
}

export default Messages
